import styled from 'styled-components'
import { border, layout, margin, padding } from 'styled-system'
import { themeGet } from '@styled-system/theme-get'

import { Column, Flex } from 'Components/UI/_Legacy'
import { DIV_SHOULD_FORWARD_PROP } from 'Config/shouldForwardProp'

const shouldForwardProp = prop => {
  return !DIV_SHOULD_FORWARD_PROP.includes(String(prop))
}

export const Container = styled(Flex)
  .attrs({
    flexDirection: ['column', 'column', 'row'],
  })
  .withConfig({
    shouldForwardProp,
  })`
  height: 100%;
`

export const PhotoHolder = styled.div
  .attrs({
    width: [1, 1, 210, 281],
    minHeight: [245, 245, 275],
    borderBottomLeftRadius: [0, 0, 20],
    borderBottomRightRadius: [0, 0, 20],
    borderTopLeftRadius: [15, 15, 20],
    borderTopRightRadius: [15, 15, 20],
    maxHeight: ['unset', 'unset', 275, 275, 290],
    maxWidth: ['100%', '100%', '270px', 'unset'],
  })
  .withConfig({
    shouldForwardProp,
  })`
  display: flex;
  overflow: hidden;
  flex-shrink: 0;

  * {
    border-radius: inherit;
  }

  ${border}
  ${margin}
  ${layout}
`

export const TextHolder = styled(Column)
  .attrs({
    px: [7, 7, 9, 9, 11],
    py: [5, 5, 7, 7, 9],
    borderBottomLeftRadius: [15, 15, 20],
    borderBottomRightRadius: [15, 15, 20],
    borderTopLeftRadius: [0, 0, 20],
    borderTopRightRadius: [0, 0, 15, 20],
  })
  .withConfig({
    shouldForwardProp,
  })`
  justify-content: flex-start;
  flex-grow: 1;
  flex-direction: column;
  border: 1px solid ${themeGet('colors.softPeach')};

  ${border}
  ${padding}
`
